module.exports = __webpack_public_path__ + "static/media/md-train.7ca851cd.svg";